import { createI18n } from 'vue-i18n';
import store from '@/store';
import en from '@/locale/en.js';
import tl from '@/locale/tl.js';

const i18n = createI18n({
  legacy: false, 
  globalInjection: true, // Ensure global injection is enabled
  locale: store.state.locale,
  fallbackLocale: 'en', 
  messages: {
      en,
      tl,
  },
});

export default i18n;